import React from 'react';
import CloverPointConfigForm from 'forms/CloverPointConfigForm';

export default (): JSX.Element => <CloverPointConfigForm />;
